const ScreenSizes = {
    Mobile: 620
};
export default ScreenSizes;